export default __webpack_public_path__ + "static/media/teste_logo_sm.a62b0636.png";